import React, { useState } from 'react';
import { Card, CardContent } from '../../../components/ui/card';
import { HardHat, Users } from 'lucide-react';
import EquipmentRegistry from './EquipmentRegistry';
import ResourceAllocations from './ResourceAllocations';

const ERPResources = () => {
  const [activeTab, setActiveTab] = useState('equipment');

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Resource Management</h1>
          <p className="text-gray-600 mt-1">Equipment and resource allocations</p>
        </div>
      </div>

      <div className="mb-6 border-b">
        <div className="flex gap-4">
          <button
            onClick={() => setActiveTab('equipment')}
            className={`pb-3 px-4 font-medium flex items-center gap-2 ${
              activeTab === 'equipment'
                ? 'border-b-2 border-primary text-primary'
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            <HardHat size={18} />
            Equipment Registry
          </button>
          <button
            onClick={() => setActiveTab('allocations')}
            className={`pb-3 px-4 font-medium flex items-center gap-2 ${
              activeTab === 'allocations'
                ? 'border-b-2 border-primary text-primary'
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            <Users size={18} />
            Resource Allocations
          </button>
        </div>
      </div>

      {activeTab === 'equipment' && <EquipmentRegistry />}
      {activeTab === 'allocations' && <ResourceAllocations />}
    </div>
  );
};

export default ERPResources;